import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from '../../actions/constant';
import therapyPlanningService from '../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  GET_THERAPY_PLANNING_PATIENT_FAILURE,
  GET_THERAPY_PLANNING_PATIENT_REQUEST,
  GET_THERAPY_PLANNING_PATIENT_SUCCESS,
} = therapyPlanningAction;

function* getIsTherapyPlanningPatient(payload: any): SagaReturnType<any> {
  try {
    const response = yield call(
      therapyPlanningService.getIsTherapyPlanningPatient,
      payload?.payload
    );
    if (response?.status === 200) {
      yield put({ type: GET_THERAPY_PLANNING_PATIENT_SUCCESS, payload: response?.data });
    } else {
      throw response?.data;
    }
  } catch (error) {
    yield put({ type: GET_THERAPY_PLANNING_PATIENT_FAILURE, payload: error });
  }
}

function* getIsTherapyPlanningPatientSaga() {
  yield takeEvery(GET_THERAPY_PLANNING_PATIENT_REQUEST, getIsTherapyPlanningPatient);
}

export default getIsTherapyPlanningPatientSaga;
